import { RefObject } from "react";

import { useRouter } from "next/router";
import PanelHeader from "@/view/PanelHeader";

import { Assignment } from "@/types/models/Assignment.interface";
import { IGeniusButtonEventProperties } from "@/view/GeniusContent/GeniusActivityPanel/GeniusActivityPanel.constant";
import AssignmentInstructions from "@/view/AssignmentInstructions/AssignmentInstructions";
import {
  drawerContainerCss,
  titleCss,
} from "./GeniusAssignmentContainer.style";

interface GeniusAssignmentContainerProps {
  assignments: Assignment[];
  assignmentsLoading: boolean;
  backButtonEventProperties: IGeniusButtonEventProperties;
  closeButtonEventProperties: IGeniusButtonEventProperties;
  onClickBackButton: () => void;
  onClickCloseButton?: () => void;
  shouldFocusCloseButtonRef: RefObject<boolean>;
}

export const GeniusAssignmentContainer = ({
  assignments,
  assignmentsLoading,
  backButtonEventProperties,
  closeButtonEventProperties,
  onClickCloseButton,
  onClickBackButton,
  shouldFocusCloseButtonRef,
}: GeniusAssignmentContainerProps) => {
  const router = useRouter();
  const {
    query: { contentId, assignmentId },
  } = router;

  const assignmentData = (assignments || []).find((assignment) => {
    return assignment.assignment_id === Number(assignmentId);
  });

  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        closeButtonEventProperties={closeButtonEventProperties}
        backButtonEventProperties={backButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Assignment</h2>
      </PanelHeader>

      <div css={drawerContainerCss}>
        <AssignmentInstructions
          assignmentData={assignmentData}
          assignmentsLoading={assignmentsLoading}
          currentLevelId={contentId as string}
        />
      </div>
    </>
  );
};

export default GeniusAssignmentContainer;
